import { render, staticRenderFns } from "./TemplateManager.vue?vue&type=template&id=67cc0a05&scoped=true&"
import script from "./TemplateManager.vue?vue&type=script&lang=js&"
export * from "./TemplateManager.vue?vue&type=script&lang=js&"
import style0 from "../Style/template-manager.scss?vue&type=style&index=0&id=67cc0a05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cc0a05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67cc0a05')) {
      api.createRecord('67cc0a05', component.options)
    } else {
      api.reload('67cc0a05', component.options)
    }
    module.hot.accept("./TemplateManager.vue?vue&type=template&id=67cc0a05&scoped=true&", function () {
      api.rerender('67cc0a05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/TemplateManager.vue"
export default component.exports